export type TPanningModelType = 'HRTF' | 'equalpower';
